module.exports = __webpack_public_path__ + "static/media/Tazón de Desayuno con Té Matcha.5308618b.webp";